import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=4a118917&scoped=true&"
import script from "./Framework.vue?vue&type=script&lang=js&"
export * from "./Framework.vue?vue&type=script&lang=js&"
import style0 from "./Framework.vue?vue&type=style&index=0&id=4a118917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a118917",
  null
  
)

export default component.exports